import { OrderEditData } from "types/Order";

// GraphQL returns a card relation; the editable form stores only its ID.
export function orderFormData(data: any): Partial<OrderEditData> {
  if (!data) return {};
  const fields: (keyof OrderEditData)[] = [
    "id", "paymentType", "paymentStatus", "shippingMethod", "trackingNumber1",
    "trackingNumber2", "specialInstructions", "watchTracking1", "watchTracking2",
    "sendShippedEmail", "misc", "note", "useUpsFedexAcct", "customerPaysShipping",
    "dateWasPlaced",
  ];
  const result = Object.fromEntries(fields
    .filter((field) => data[field] !== undefined)
    .map((field) => [field, data[field]])) as Partial<OrderEditData>;
  if (data.clientCreditCard !== undefined) {
    result.clientCreditCardId = data.clientCreditCard?.id ?? 0;
  }
  return result;
}
